import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './common-components/header/header.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { InstructionPoupBoxComponent } from './common-components/client-instruction/instruction-poup-box/instruction-poup-box.component';
import { CommentHistoryModalComponent } from './common-components/comment-history-modal/comment-history-modal.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHeaderInterceptor } from './auth-header-interceptor';
import { ClientInstructionComponent } from './common-components/client-instruction/client-instruction.component';
import { ClientInstructionInfoComponent } from './common-components/client-instruction/client-instruction-info/client-instruction-info.component';
import { CountModelComponent } from './common-components/client-instruction/count-model/count-model.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AgeingDashboardReportComponent } from './common-components/ageing-dashboard-report/ageing-dashboard-report.component';
import { UserManagementComponent } from './common-components/user-management/user-management.component';
import { ProductivityReportComponent } from './common-components/productivity-report/productivity-report.component';
import { LoadingPageComponent } from './common-components/loading-page/loading-page.component';
import { LoginComponent } from './common-components/login/login.component';
import { TwoFactorAuthComponent } from './common-components/two-factor-auth/two-factor-auth.component';
import { WelcomePageComponent } from './common-components/welcome-page/welcome-page.component';
import { ForgotPasswordComponent } from './common-components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './common-components/reset-password/reset-password.component';
import { ChangePasswordComponent } from './common-components/change-password/change-password.component';
import { ForgotPasswordNewComponent } from './common-components/forgot-password-new/forgot-password-new.component';
import { BucketMappingComponent } from './common-components/bucket-mapping/bucket-mapping.component';
import { EmployeeSelectorModalComponent } from './common-components/employee-selector-modal/employee-selector-modal.component';
import { CitraAuditReportComponent } from './common-components/reports/citra-audit-report/citra-audit-report.component';
import { MisReportComponent } from './common-components/reports/mis-report/mis-report.component';
import { PcnReportComponent } from './common-components/reports/pcn-report/pcn-report.component';
import { ProductionReportComponent } from './common-components/reports/production-report/production-report.component';
import { SimpleReportComponent } from './common-components/reports/simple-report/simple-report.component';
import { UnworkedAccountsReportComponent } from './common-components/reports/unworked-accounts-report/unworked-accounts-report.component';
import { ProductionEmployeeSelectorModalComponent } from './common-components/reports/production-report/production-employee-selector-modal/production-employee-selector-modal.component';
import { ProjectAndPriorityDashboardComponent } from './common-components/project-and-priotity/project-and-priority-dashboard/project-and-priority-dashboard.component';
import { ProjectAndPriorityDeallocationComponent } from './common-components/project-and-priotity/project-and-priority-deallocation/project-and-priority-deallocation.component';
import { ProjectAndPriorityDeallocationPageComponent } from './common-components/project-and-priotity/project-and-priority-deallocation/project-and-priority-deallocation-page/project-and-priority-deallocation-page.component';
import { ProjectSelectorModalComponent } from './common-components/project-and-priotity/project-and-priority-report/project-selector-modal/project-selector-modal.component';
import { ProjectAndPriorityReportComponent } from './common-components/project-and-priotity/project-and-priority-report/project-and-priority-report.component';
import { ProjectDeactivateConfirmationComponent } from './common-components/project-and-priotity/project-and-priority-dashboard/project-deactivate-confirmation/project-deactivate-confirmation.component';
import { ProjectReallocationComponent } from './common-components/project-and-priotity/project-and-priority-dashboard/project-reallocation/project-reallocation.component';
import { ConcluderReportComponent } from './common-components/concluder/concluder-report/concluder-report.component';
import { SupervisorInboxMappingComponent } from './common-components/concluder/concluder-inbox-mapping/supervisor-inbox-mapping/supervisor-inbox-mapping.component';
import { DashboardComponent } from './common-components/dashboard/dashboard.component';
import { UserMenuMappingComponent } from './common-components/user-menu-mapping/user-menu-mapping.component';
import { AssignMenuComponent } from './common-components/user-menu-mapping/assign-menu/assign-menu.component';
import { ClientConfigurationComponent } from './common-components/client-configuration/client-configuration.component';
import { SpecialProjectComponent } from './common-components/client-configuration/special-project/special-project.component';
import { SaagComponent } from './common-components/client-configuration/saag/saag.component';
import { ProviderSignatureModalComponent } from './common-components/client-configuration/provider/provider-signature-modal/provider-signature-modal.component';
import { ProviderModelComponent } from './common-components/client-configuration/provider/provider-model/provider-model.component';
import { ProviderComponent } from './common-components/client-configuration/provider/provider.component';
import { PcnConfigurationComponent } from './common-components/client-configuration/pcn-configuration/pcn-configuration.component';
import { InventoryModalComponent } from './common-components/client-configuration/inventory/inventory-modal/inventory-modal.component';
import { InventoryComponent } from './common-components/client-configuration/inventory/inventory.component';
import { SettingTemplateModalComponent } from './common-components/client-configuration/insurance/setting-template-modal/setting-template-modal.component';
import { InsuranceModalComponent } from './common-components/client-configuration/insurance/insurance-modal/insurance-modal.component';
import { InsuranceComponent } from './common-components/client-configuration/insurance/insurance.component';
import { FormulaModalComponent } from './common-components/client-configuration/formula/formula-modal/formula-modal.component';
import { FormulaComponent } from './common-components/client-configuration/formula/formula.component';
import { DropdownModalComponent } from './common-components/client-configuration/dropdown/dropdown-modal/dropdown-modal.component';
import { DropdownComponent } from './common-components/client-configuration/dropdown/dropdown.component';
import { ClientComponent } from './common-components/client-configuration/client/client.component';
import { AddPcnConfigurationComponent } from './common-components/client-configuration/add-pcn-configuration/add-pcn-configuration.component';
import { AppealComponent } from './common-components/client-configuration/appeal/appeal.component';
import { DeactivateProjectComponent } from './common-components/client-configuration/special-project/deactivate-project/deactivate-project.component';
import { CitraEmployeeMappingComponent } from './common-components/citra-employee-mapping/citra-employee-mapping.component';
import { GlobalInsuranceComponent } from './common-components/mange-insurance/global-insurance/global-insurance.component';
import { EditGlobalModalComponent } from './common-components/mange-insurance/global-insurance/edit-global-modal/edit-global-modal.component';
import { MappingModalComponent } from './common-components/mange-insurance/global-mapping/mapping-modal/mapping-modal.component';
import { GlobalMappingComponent } from './common-components/mange-insurance/global-mapping/global-mapping.component';
import { AutoAllocationComponent } from './common-components/auto-allocation/auto-allocation.component';
import { StandardCommentComponent } from './common-components/standard-comment/standard-comment.component';
import { ClientAssistanceComponent } from './common-components/client-assistance/client-assistance.component';
import { AssistanceModalComponent } from './common-components/client-assistance/assistance-modal/assistance-modal.component';
import { ConcluderDashboardComponent } from './common-components/concluder-dashboard/concluder-dashboard.component';
import { AllocatedCountModalComponent } from './common-components/concluder-dashboard/allocated-count-modal/allocated-count-modal.component';
import { ConcluderHelpImageComponent } from './common-components/concluder-dashboard/concluder-help-image/concluder-help-image.component';
import { FooterComponent } from './common-components/footer/footer.component';
import { NotFoundComponent } from './common-components/not-found/not-found.component';
import { MultipleTabComponent } from './common-components/multiple-tab/multiple-tab.component';
import { CiinraAuditReportComponent } from './common-components/reports/ciinra-audit-report/ciinra-audit-report.component';
export const MY_CUSTOM_FORMATS = {
  datePickerInput: 'MM/DD/YYYY'
};
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonMessageModalComponent } from './common-components/common-message-modal/common-message-modal.component';
import { CommonDropdownSearchComponent } from './common-dropdown-search/common-dropdown-search.component';
import { ShowTimerComponent } from './common-components/show-timer/show-timer.component';
import { TmsReportComponent } from './common-components/reports/tms-report/tms-report.component';
import { ContactSupportComponent } from './common-components/contact-support/contact-support/contact-support.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

const httpInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: AuthHeaderInterceptor, multi: true }]


@NgModule({
  declarations: [
    HeaderComponent,
    InstructionPoupBoxComponent, // ["Supervisor", "QC", "Client Supervisor"]
    CommentHistoryModalComponent,
    ClientInstructionComponent, // ["Supervisor", "QC", "Client Supervisor"]
    ClientInstructionInfoComponent, // ["Supervisor", "QC", "Client Supervisor"]
    CountModelComponent, // ["Supervisor", "QC", "Client Supervisor"]
    AgeingDashboardReportComponent, // ["Supervisor", "Client Supervisor"]
    UserManagementComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Client Supervisor"]
    ProductivityReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Client Supervisor"]
    LoadingPageComponent,
    LoginComponent,
    TwoFactorAuthComponent,
    WelcomePageComponent,
    ForgotPasswordComponent,
    ForgotPasswordNewComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    BucketMappingComponent, // ["Administrator", "Admin", "Supervisor"]
    EmployeeSelectorModalComponent,
    CitraAuditReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"]
    MisReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"]
    TmsReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"]
    PcnReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"]
    ProductionReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"]
    ProductionEmployeeSelectorModalComponent,
    SimpleReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"]
    UnworkedAccountsReportComponent, // ["Administrator", "Admin", "Director", "Manager", "Supervisor", "Controller"]
    ProjectAndPriorityDashboardComponent, // ["Supervisor", "Admin"]
    ProjectReallocationComponent,
    ProjectDeactivateConfirmationComponent,
    ProjectAndPriorityDeallocationComponent, // ["Admin", "Supervisor"]
    ProjectAndPriorityDeallocationPageComponent,
    ProjectAndPriorityReportComponent, // ["Supervisor", "Admin"]
    ProjectSelectorModalComponent,
    ConcluderReportComponent, // ["Supervisor", "Admin"]
    SupervisorInboxMappingComponent, // ["Supervisor", "Admin"],
    DashboardComponent, // ["All"]
    UserMenuMappingComponent, // ["Administrator", "Admin"]
    AssignMenuComponent,
    ClientConfigurationComponent, // ["Administrator", "Admin"]
    AddPcnConfigurationComponent,
    AppealComponent,
    ClientComponent,
    DropdownComponent,
    DropdownModalComponent,
    FormulaComponent,
    FormulaModalComponent,
    InsuranceComponent,
    InsuranceModalComponent,
    SettingTemplateModalComponent,
    InventoryComponent,
    InventoryModalComponent,
    PcnConfigurationComponent,
    ProviderComponent,
    ProviderModelComponent,
    ProviderSignatureModalComponent,
    SaagComponent,
    SpecialProjectComponent,
    DeactivateProjectComponent,
    CitraEmployeeMappingComponent, // ["Administrator", "Admin"]
    GlobalInsuranceComponent, // ["Administrator", "Admin"]
    EditGlobalModalComponent,
    GlobalMappingComponent, // ["Administrator", "Admin"]
    MappingModalComponent,
    AutoAllocationComponent, // ["Administrator", "Admin"]
    StandardCommentComponent, // ["Administrator", "Admin"]
    ClientAssistanceComponent,
    AssistanceModalComponent,
    ConcluderDashboardComponent,
    AllocatedCountModalComponent,
    ConcluderHelpImageComponent,
    FooterComponent,
    NotFoundComponent,
    MultipleTabComponent,
    CommonMessageModalComponent,
    CiinraAuditReportComponent,
    CommonDropdownSearchComponent,
    ShowTimerComponent,
    ContactSupportComponent
  ],
  imports: [
    CommonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule.withComponents([]),
    NgMultiSelectDropDownModule.forRoot(),
    NgbModule,
    DragDropModule
  ],
  exports: [
    HeaderComponent,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    InstructionPoupBoxComponent,
    CommentHistoryModalComponent,
    ClientInstructionComponent,
    ClientInstructionInfoComponent,
    CountModelComponent,
    AgeingDashboardReportComponent,
    UserManagementComponent,
    ProductivityReportComponent,
    LoadingPageComponent,
    LoginComponent,
    TwoFactorAuthComponent,
    WelcomePageComponent,
    ForgotPasswordComponent,
    ForgotPasswordNewComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    BucketMappingComponent,
    EmployeeSelectorModalComponent,
    FooterComponent,
    NotFoundComponent,
    NgbModule,
    CommonMessageModalComponent,
    CiinraAuditReportComponent,
    CommonDropdownSearchComponent,
    ShowTimerComponent,
    ContactSupportComponent
  ],
  providers: [
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
    httpInterceptorProviders
  ]
})
export class CommonModulecomponentModule { }
